import { Grid, Button, FormGroup } from '@material-ui/core';
import { FormControl, InputLabel, Select, MenuItem, Typography, TextField } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { GetPlansWithCodeCount } from '../_service/plan';
import { ServicePlan } from '../_types/serviceplan';
import Icon, { SupportedIcons } from '../common/Icon';
import { ISearchResult } from '../_types/search';
import { BulkMoveCodeResponse } from '../_types/bulk';
import { PlanByLocationSelector } from '../common/Selector/PlanByLocationSelector';
import { BulkCodeResponseDialog } from '../common/BulkCodeResponseDialog';
import { MoveCodesAPI } from '../_service/bulk';
import { ILocationSummary } from '../_types/user';
import { BulkShowResultsListButton } from '../common/BulkShowResultsListButton';


interface Props {
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    innerContainer: {
      border: '1px solid',
      borderRadius: 10,
      margin: 15,
      alignItems: 'center',
      textAlign: 'center'
    },
    arrowRow: {
      textAlign: 'center'
    },
    inputLabel: {
      fontSize: 14
    },
    warningLabel: {
      fontSize: 14,
      color: "red"
    },
    icon: {
      width: 12,
      height: 12,
      cursor: 'pointer'
    }
  })
);

const MoveCodes: React.FC<Props> = (prop: Props) => {
  const { user } = useContext(AuthContext);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [plans, setPlans] = useState<ServicePlan[]>([]);
  const [toPlans, setToPlans] = useState<ServicePlan[]>([]);

  const [fromPlan, setFromPlan] = useState<string | null>();
  const [toPlan, setToPlan] = useState<string | null>();
  const [isMoving, setIsMoving] = useState<boolean>(false);
  const [codeList, setCodeList] = useState<string[]>([]);
  const [storedCodeList, setStoredCodeList] = useState<string[]>([]);

  const classes = useStyles();
  const [amount, setAmount] = useState<number>(0);
  const [codeType, setCodeType] = useState<string>("Select Code Type");
  const [maxAmount, setMaxAmount] = useState<number>(0);
  const [fromLocation, setFromLocation] = useState<ILocationSummary | ISearchResult | null>(user.currentLocation || null);
  const [toLocation, setToLocation] = useState<ILocationSummary | ISearchResult | null>(user.currentLocation || null);


  let disabled;
  let errors: any = [];
  const changeAmount = (stringValue: string) => {
    let value = Number(stringValue.replace(/\D/g, ''));
    if (value > maxAmount) {
      setAmount(maxAmount)
    } else if (value < 0) {
      setAmount(0)
    } else {
      setAmount(value);
    }
  }

  const checkErrors = () => {
    if (codeType === "Select Code Type") {
      errors.push(<li id="selectCodeError" key="selectCodeError">Please select a code type to move</li>);
    }
    if (!fromPlan || fromPlan === "") {
      errors.push(<li id="selectFromPlanError" key="selectFromPlanError">Must select a plan to move from</li>);
    }
    if (!toPlan || toPlan === "") {
      errors.push(<li id="selectToPlanError" key="selectToPlanError">Must select a plan to move to</li>)
    }
    if (amount < 1) {
      errors.push(<li id="selectAmountError" key="selectAmountError">Codes moved must be greater than 0</li>);
    }
    if (errors.length === 0) {
      disabled = false;
    } else {
      disabled = true;
    }
    return errors;
  }

  const filterPlans = (plans: ServicePlan[]): ServicePlan[] => {
    let filteredResults: ServicePlan[] = [];
    if (codeType === "otuc") {
      for (let plansFilter = 0; plansFilter < plans.length; plansFilter++) {
        if (plans[plansFilter].has_use_code === 1) {
          filteredResults.push(plans[plansFilter])
        }
      }
    } else if (codeType === "drb") {
      for (let plansFilter = 0; plansFilter < plans.length; plansFilter++) {
        if (plans[plansFilter].has_drb_code === 1) {
          filteredResults.push(plans[plansFilter])
        }
      }
    } else {
      return plans;
    }
    return filteredResults;
  }
  const _move = async () => {
    if (codeType === "Select Code Type") return alert('Please select a code type to move');
    if (!fromPlan || fromPlan === "") return alert('Must select a plan to move from');
    if (!toPlan || toPlan === "") return alert('Must select a plan to move to');
    if (amount < 1) return alert('Must select an number of codes to move');

    setIsMoving(true);
    let response: BulkMoveCodeResponse | null = await MoveCodesAPI(fromPlan, toPlan, amount, codeType);
    if (response === null) {
      setIsMoving(false);
      return alert('Something unexpected went wrong. Check if codes were moved.');
    }
    if (response !== null) {
      setIsMoving(false);
      setFromPlan(null);
      setToPlan(null);
      if (response.codesMoved && response.codesMoved.length > 0) {
        setCodeList(response.codesMoved);
        setIsOpen(true)
      }
      if (response.codesMoved && response.codesMoved.length === 0) {
        return alert('No codes were moved. Make sure you selected the correct plans.')
      }
      if (user.currentLocation) {
        //what is this
        GetPlansWithCodeCount(user.currentLocation.id).then(res => {
          setPlans(res);
          setToPlans(res);
        });
      } else {
        if (fromLocation !== null) {
          GetPlansWithCodeCount(fromLocation?.id).then(res => {
            setPlans(res);
          });
        }

        if (toLocation !== null) {
          GetPlansWithCodeCount(toLocation?.id).then(res => {
            setToPlans(res);
          });
        }
      }
    }
  }

  React.useEffect(() => {
    for (var plansFilter = 0; plansFilter < plans.length; plansFilter++) {
      if (plans[plansFilter].id === fromPlan) {
        if (codeType === 'otuc' && plans[plansFilter].otuc_remaining !== undefined) {
          setMaxAmount(Number(plans[plansFilter].otuc_remaining))
        } else if (codeType === 'drb' && plans[plansFilter].drb_remaining !== undefined) {
          setMaxAmount(Number(plans[plansFilter].drb_remaining))
        } else {
          setMaxAmount(0)
        }
      }
    }
  }, [fromPlan, codeType, plans.length]);

  React.useEffect(() => {
    setFromPlan(null);
    setToPlan(null);
    setPlans([]);
    setToPlans([]);

    if (user.currentLocation) {
      GetPlansWithCodeCount(user.currentLocation.id).then(res => {
        setPlans(res);
        setToPlans(res);
      });
    }
  }, [user.currentLocation]);

  React.useEffect(() => {
    setFromPlan(null);
    setPlans([]);

    if (fromLocation) {
      GetPlansWithCodeCount(fromLocation.id).then(res => {
        setPlans(res);
      });
    }
  }, [fromLocation]);

  React.useEffect(() => {
    setToPlan(null);
    setToPlans([]);

    if (toLocation) {
      GetPlansWithCodeCount(toLocation.id).then(res => {
        setToPlans(res);
      });
    }
  }, [toLocation]);


  checkErrors();
  return (
    <>
      <Grid item>
        <h3>Move Codes Between Plans</h3>
        <p>First, select a location and a plan whose codes you want to move. Second, select a location and a plan you want to move codes into. </p>
      </Grid>

      <Grid item xs={12} sm={5}>
        <FormControl className={classes.formControl}>
          <InputLabel id="select-label">{"Select Code Type"}</InputLabel>
          <Select
            labelId="select-label"
            id="select-outlined"
            label={"Select Code"}
            value={codeType}
            onChange={(e) => { setCodeType(String(e.target.value)) }}>
            <MenuItem value={'Select Code Type'}>Select Code Type</MenuItem>
            <MenuItem value={'drb'}>DRB Codes</MenuItem>
            <MenuItem value={'otuc'}>One Time Use Codes (OTUC) </MenuItem>
          </Select>

        </FormControl>
      </Grid>

      {/* LOCATION 1 */}
      <PlanByLocationSelector
        onLocationChange={(newValue: ISearchResult | null) => { 
          setFromLocation(newValue);
        }}
        planInputLabel='From'
        onPlanChange={(event: any) => setFromPlan(event.target.value as string)}
        planValue={fromPlan || ''}
        plans={(filterPlans(plans)) ?? null}
        codeTypeCheck={codeType}
      />

      <Grid container className={classes.arrowRow}>
        <Grid item xs={4} sm={4}>{<Icon iconName={SupportedIcons.ArrowDownward} color='primary' />}</Grid>
        <Grid item xs={4} sm={4}>{<Icon iconName={SupportedIcons.ArrowDownward} color='primary' />}</Grid>
        <Grid item xs={4} sm={4}>{<Icon iconName={SupportedIcons.ArrowDownward} color='primary' />}</Grid>
      </Grid>

      {/* LOCATION 2 */}
      <PlanByLocationSelector
        onLocationChange={(newValue: ISearchResult | null) => { 
          setToLocation(newValue);
        }}
        planInputLabel='To'
        onPlanChange={(event: any) => setToPlan(event.target.value as string)}
        planValue={(toPlan) || ''}
        plans={(filterPlans(toPlans)) ?? null}
        codeTypeCheck={codeType}
      />

      <Grid container style={{ margin: "10px" }}>
        <Grid item sm={6} xs={6} >
          <div className={classes.warningLabel}
            title="Errors that need to be handled">
            <ul>
              {errors}
            </ul>
          </div>
        </Grid>
        <Grid item sm={6} xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
          <FormControl >
            <Typography className={classes.inputLabel}
              title="Enter the number of codes you wish to move to the new plan.">
              Number of Codes to Move
              <Icon className={classes.icon} iconName={SupportedIcons.InfoOutlined} color="primary" />
            </Typography>
            <FormGroup row>
              <TextField variant="outlined"
                InputProps={{
                  style: {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    marginTop: "1px"
                  },
                }}
                inputProps={{ style: { textAlign: 'center' } }}
                type="text"
                name="input"
                value={amount}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => { changeAmount((e.target.value)) }}
              />

              <Button
                variant="outlined"
                color="primary"
                onClick={() => setAmount(maxAmount)}
                style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, height: "100%" }}
              >
                Max
              </Button>
            </FormGroup>
            {((amount === maxAmount) && maxAmount !== 0) ? "Maximum number reached" : ""}
          </FormControl>
        </Grid>
      </Grid>

      {isMoving ? <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-end" }}><p>Moving Codes, please wait... This can take several minutes...</p></Grid> :
        <>
          <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-end", height: "2.85em", flexDirection: "column" }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => _move()}
              disabled={isMoving || disabled}>
              Move Codes
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-start", flexDirection: "column" }}>
            <BulkShowResultsListButton
              hide={(storedCodeList.length === 0)}
              title={"Successfully Moved " + storedCodeList.length + (storedCodeList.length === 1 ? " Code" : " Codes")}
              hideButton={true}
            />
          </Grid>
        </>
      }
      <Grid item xs={12} sm={12} style={{ display: "flex", justifyContent: "flex-end" }}>
        {(codeList.length > 0) && <BulkCodeResponseDialog
          title={"Successfully Moved " + codeList.length + (codeList.length === 1 ? " Code" : " Codes")}
          isOpen={isOpen}
          handleClose={() => {
            setIsOpen(false);
            setStoredCodeList(codeList);
            setCodeList([]);
          }} />}
      </Grid>
    </>
  );
}

export default MoveCodes;